import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useOrganizationIdWithFallback } from "@/organization/api";
import { z } from "zod";

const searchSchema = z.object({
  installSensorKitSerialNumber: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/organization/')({
  component: RouteComponent,
  validateSearch: searchSchema,
})

function RouteComponent() {
  const organizationId = useOrganizationIdWithFallback();
  const search = Route.useSearch();

  if (!organizationId) {
    return <Navigate to="/organization/no-organizations" />;
  }

  // If installSensorKitSerialNumber is present, redirect to install flow
  if (search.installSensorKitSerialNumber) {
    return (
      <Navigate
        to="/organization/$organizationId/install-flow"
        params={{ organizationId }}
        search={{
          step: 'intro',
          installSensorKitSerialNumber: search.installSensorKitSerialNumber
        }}
      />
    );
  }

  // Default: redirect to organization dashboard
  return <Navigate to="/organization/$organizationId" params={{ organizationId }} />;
}
